import Swiper from 'swiper/bundle';

function initSliderPictures() {
	document.querySelectorAll(".slide-pictures-container").forEach(slide => {
		const nextButton = slide.querySelector(".swiper-button-next");
		const prevButton = slide.querySelector(".swiper-button-prev");

		const swiper = new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 32,
			centeredSlides: true,
			grabCursor: 'true',

			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		});
	});
}

if (document.querySelector(".slide-pictures-container")) {
	initSliderPictures();
}
